import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolsHammer3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "tools-hammer-3" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.132,13.318a3.7,3.7,0,0,1,5.237-5.236L21.082,12.8a3.7,3.7,0,0,1,0,5.237l-2.1-2.1a3.967,3.967,0,0,0-5.237,0Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 5.876,
			y: .975,
			width: 3.703,
			height: 7.406,
			transform: "translate(5.571 -4.094) rotate(45)"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 10.608,
			y1: 4.416,
			x2: 13.227,
			y2: 7.034
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 7.466,
			y1: 7.558,
			x2: 10.084,
			y2: 10.176
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M10.308,12.048,2.3,20.059a1.836,1.836,0,0,0,2.6,2.6l7.787-7.788"
		})
	]
});
export default SvgToolsHammer3;
